import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';

import { useTenantCapability } from './feature';

/** Settings > Manage Users > Access history (the route; kept here so links need no page import). */
export const ACCESS_HISTORY_LINK = '/settings/access-history';

/**
 * "Access history" button for the pages the History tab left (Access review,
 * Approvals): shown when the identity service's capabilities say `history`.
 */
export function AccessHistoryLink({ enabled = true }: { enabled?: boolean }) {
  const show = useTenantCapability('history', enabled);
  if (!show) return null;
  return (
    <Button
      component={RouterLink}
      to={ACCESS_HISTORY_LINK}
      color='secondary'
      variant='outlined'
      startIcon={<HistoryIcon />}
      data-testid='access-history-link'
    >
      Access history
    </Button>
  );
}

/** Show Settings > Manage Users > Access history? capabilities.history; no call while closed. */
export function useAccessHistoryLink(active: boolean): boolean {
  return useTenantCapability('history', active);
}
